import { customers, customerActionType,SAVE_CUSTOMERS } from './types';

export function SaveCustomers(customers: customers): customerActionType {
  return {
    type: SAVE_CUSTOMERS,
    payload: customers,
  };
}
